export const tourGuideSteps = [
  {
    selector: "#client-select",
    content:
      "This is the client friendly name.",
  },
  {
    selector: "#client-environment-select",
    content:
      "This dropdown selects the environment for which you want to search messages.",
  },
  {
    selector: "#channel-select",
    content:
      "This dropdown selects the channel for which you want to search messages.",
  },
  {
    selector: "#message-filter-card",
    content:
      "This allows the filtering for a specific message.",
  },
  {
    selector: "#message-select-action-buttons",
    content:
      "This buttons allow ease of selection and un-selection of messages to reprocess messages in bulk.",
  },
  {
    selector: "#message-data-grid-card .rt-thead.-header",
    content:
      "This data grid lists all the messages that fit the filtering criteria above.",
  },
  {
    selector: "#Messages-column-3",
    content:
      "The message info column. Press the below 'View Message' link to be directed to the page detailing the content of the message.",
  },
];
